import { TimesheetsClient } from './timesheets-client';
export default function TimesheetsPage() { return <TimesheetsClient />; }
